<!-- 待办 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" v-model="queryParam.applyState">
                <a-select-option :value="0">待审批</a-select-option>
                <a-select-option :value="1">待评价</a-select-option>
                <a-select-option :value="2">结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag v-model="queryParam.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')" dictCode="ticketsEmergency" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择工单类型')">
                <a-select-option :value="3">{{ $t('报停') }}</a-select-option>
                <a-select-option :value="4">{{ $t('复接') }}</a-select-option>
                <a-select-option :value="8">{{ $t('用户信息变更') }}</a-select-option>
                <a-select-option :value="9">{{ $t('用水性质变更') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
    
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <template slot="ticketsNum" slot-scope="text,record">
          <a-button type="link" size="small" @click="onWork(record)" v-if="record.ticketsNum">{{ record.ticketsNum }}</a-button>
        </template>

        <template slot="ticketsState" slot-scope="text,record">
          <!-- 报停 -->
          <span v-if="record.ticketsType == 3">
              <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
              </template>
              <template v-else>
              {{meterTypeList[text]}}
              </template>
          </span>
          <!-- 复接 -->
          <span v-if="record.ticketsType == 4">
              <template v-if="record.ticketsState == -1">
              {{ $t('已结束') }}
              </template>
              <template v-else>
              {{meterTypeList[text]}}
              </template>
          </span>
        </template>

        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="red" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="yellow" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="blue" v-else-if="text == 3">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>

        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>

        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <!-- <template slot="applyType" slot-scope="text,record">
          {{record.applyType==0?'报停':record.applyType==1?'报停恢复':record.applyType==2?'销户':record.applyType==3?'用户信息变更':record.applyType==4?'价格信息变更':record.applyType==5?'用户过户':''}}
        </template> -->

        <span slot="action" slot-scope="text, record">

          <template>

            <!-- 报停 -->
            <template v-if="record.ticketsType == 3 && record.ticketsState > 0">
              <template v-if="record.ticketsState == 1">
                <a-popconfirm :title="$t('确定接单吗?')" @confirm="() => handleOrder(record)">
                  <a>{{ $t('接单') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 4">
                <a @click="handleArchive(record)">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

            </template>

            <!-- 复接 -->
            <template v-else-if="record.ticketsType == 4 && record.ticketsState > 0">

              <template v-if="record.ticketsState == 1">
                <a-popconfirm :title="$t('确定接单吗?')" @confirm="() => handleOrder(record)">
                  <a>{{ $t('接单') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 4">
                <a @click="handleArchive(record)">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

              <!-- <a-divider type="vertical" v-if="record.ticketsState > 0 && record.ticketsState < 4" /> -->
            </template>

            <!-- 用户信息变更 -->
            <template v-if="record.ticketsType == 8 && record.ticketsState > 0">

              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="handleArchive(record)">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>

            </template>

            <!-- 用水性质变更 -->
            <template v-if="record.ticketsType == 9 && record.ticketsState > 0">

              <template v-if="record.ticketsState == 1">
                <a @click="handleTearDownAndInstall(record)">{{ $t('审核工单') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 2">
                <a @click="handleTearDownAndInstall(record)">{{ $t('处理') }}</a>
                <a-divider type="vertical" />
              </template>

              <template v-if="record.ticketsState == 3">
                <a @click="handleArchive(record)">{{ $t('归档') }}</a>
                <a-divider type="vertical" />
              </template>
            </template>

          </template>

          <!--  只有审批状态为 审批中 才允许审批 -->
          <!-- <a v-if="record.applyState == 0" @click="handleApproval(record)">审批</a>
          <a-divider type="vertical" />
          <a @click="handleApprovalHistory(record)">审批历史</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record,'detail')">详情</a> -->

          <a @click="handleUserInfoChange(record,'用变审')">{{ $t('用变审') }}</a>
          <a-divider type="vertical" />
          <a @click="handleUserInfoChange(record,'详情')">{{ $t('用变详情') }}</a>
          <a-divider type="vertical" />
          <a @click="handleUseWaterChange(record,'水变审')">{{ $t('水变审') }}</a>
          <a-divider type="vertical" />
          <a @click="handleUseWaterChange(record,'详情')">{{ $t('水变详情') }}</a>
          <a-divider type="vertical" />
          <a @click="handleTransferUser(record,'详情')">{{ $t('过户') }}</a>
        </span>
      </a-table>
    </div>
    

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
    <handleModal ref="hanldeModalForm" @ok="modalFormOk"></handleModal>
    <TearDownAndInstallOrderApprove ref="tearDownAndInstallOrderApproveForm" @ok="modalFormOk"></TearDownAndInstallOrderApprove>
    <!-- 用户信息变更 -->
    <UserInfoChange ref="userInfoChangeForm" @ok="modalFormOk"></UserInfoChange>
    <!-- 用水性质变更 -->
    <UseWaterChange ref="useWaterChangeForm" @ok="modalFormOk"></UseWaterChange>
    <!-- 过户 -->
    <TransferUser ref="transferUserForm" @ok="modalFormOk"></TransferUser>
    <rateModal ref="rateModalForm" @ok="modalFormOk"></rateModal>
    <approvalHistoryModal ref="approvalHistoryModalForm" />
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './modal'
  import handleModal from './handleModal'
  import TearDownAndInstallOrderApprove from './TearDownAndInstallOrderApprove.vue'
  import UserInfoChange from './modules/UserInfoChange.vue'
  import UseWaterChange from './modules/UseWaterChange.vue'
  import TransferUser from './modules/TransferUser.vue'
  import rateModal from './rateModal'
  import approvalHistoryModal from './approvalHistoryModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import moment from 'moment';
  import Vue from 'vue'
  import { SYS_TYPE } from "@/store/mutation-types"
  import store from '@/store/'

  export default {
    name: 'WeChatListUnProcessed',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      handleModal,
      rateModal,
      approvalHistoryModal,
      JInput,
      TearDownAndInstallOrderApprove,
      UserInfoChange,
      UseWaterChange,
      TransferUser,
    },
    data () {
      return {
        filterDictTextByCache: filterDictTextByCache,
        url: {
          list: "/jeecg-engineering/ticket/tickets/list",
          delete: "/jeecg-charge/meter/wechatUserApply/delete",
          deleteBatch: "/jeecg-charge/meter/wechatUserApply/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
        queryParam: {
          workState: 1,
          belongModule:'tickets',
        },
      }
    },
    created() {},
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'状态',
          //   align:"center",
          //   dataIndex: 'applyState',
          //   scopedSlots: { customRender: 'applyState' }
          // },
          {
            title: this.$t('关联工单'),
            align:"center",
            dataIndex: 'ticketsNum',
            width:180,
            ellipsis: true,
            scopedSlots: { customRender: 'ticketsNum' }
          },
           {
            title: this.$t('工单类型'),
            align:"center",
            dataIndex: 'ticketsType',
            customRender: (t, r, index) => {
              if(t == 0){
                return this.$t('换表')
              }else if(t == 1){
                return this.$t('个人新装')
              }else if(t == 2){
                return this.$t('故障报修')
              }else if(t == 3){
                return this.$t('报停')
              }else if(t == 4){
                return this.$t('复接')
              }else if(t == 5){
                return this.$t('企业新装')
              }else if(t == 6){
                return this.$t('用水')
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单紧急程度'),
            align:"center",
            dataIndex: 'ticketsEmergency',
            // customRender: function (text) {
            //   return filterDictTextByCache('ticketsEmergency', text)
            // },
            scopedSlots: { customRender: 'ticketsEmergency' },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工单状态'),
            dataIndex: 'ticketsState',
            align:"center",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'ticketsState' }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户电话'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true,
          },
          // {
          //   title:'申请类型',
          //   align:"center",
          //   dataIndex: 'applyType',
          //   scopedSlots: { customRender: 'applyType' },
          //   width:150,
          //   ellipsis: true,
          // },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'applyTime',
            width:150,
            ellipsis: true,
          },
          // {
          //   title:'审批状态',
          //   align:"center",
          //   dataIndex: 'applyState',
          //   customRender:function (t,r,index) {
          //     if(t == 0){
          //       return '审批中'
          //     }else if(t == 1){
          //       return '处理中'
          //     }else if(t == 2){
          //       return '用户反馈'
          //     }else if(t == 3){
          //       return '已结束'
          //     }else if(t == 4){
          //       return '已撤销'
          //     }else if(t == 5){
          //       return '已驳回'
          //     }else{
          //       return '草稿'
          //     }
          //   },
          //   width:100,
          //   ellipsis: true,
          // },
          {
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'handleName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'handleTime',
            width:150,
            ellipsis: true,
          }, 
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:170,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      searchReset(){
        this.queryParam = {
          applyState: 1
        };
        this.loadData();
      },
      handleDetail(row){
        // 报停0 复接1 详情页面
        if ([0, 1].includes(row.applyType)) {
          if (this.$refs.tearDownAndInstallOrderApproveForm) {
            this.$refs.tearDownAndInstallOrderApproveForm.init(row, "详情");
          } else {
            console.error('组件引用不存在，请检查组件是否已正确加载');
          }
          return;
        }

        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail');
        });
      },
      // 审批
      handleApproval(row){
        // 报停0 复接1 审批页面
        if ([0, 1].includes(row.applyType)) {
          const actionType = row.applyType === 0 ? "报停" : "复接";
          
          if (this.$refs.tearDownAndInstallOrderApproveForm) {
            this.$refs.tearDownAndInstallOrderApproveForm.init(row, actionType);
          } else {
            console.error('组件引用不存在，请检查组件是否已正确加载');
          }
          return;
        }
        if(row.isRefuse == 1){
          this.$message.warning(this.$t('已驳回，等待用户重新提交后审批'));
        }else{
          this.$nextTick(()=>{
            this.$refs.hanldeModalForm.init(row);
          });
        }
      },
      handleApprovalHistory(row){
        this.$nextTick(()=>{
          this.$refs.approvalHistoryModalForm.init(row);
        });
      },
      // 用户信息变更
      handleUserInfoChange(row,type){
        this.$nextTick(()=>{
          this.$refs.userInfoChangeForm.init(row,type);
        });
      },
      // 用水性质变更
      handleUseWaterChange(row,type){
        this.$nextTick(()=>{
          this.$refs.useWaterChangeForm.init(row,type);
        });
      },
      // 过户
      handleTransferUser(row,type){
        this.$nextTick(()=>{
          this.$refs.transferUserForm.init(row,type);
        });
      },
      // 跳转工单记录
      onWork(row){
        Vue.ls.set(SYS_TYPE,8);
        store.commit('SET_SYSTYPE', 8);
        // this.$router.replace({ path: "/workOrderManagement/workManagement/index",query:{ticketsNum:row.ticketsNum} });
        this.$router.push({ 
          path: "/workOrderManagement/workManagement/index",
          query: { ticketsNum: row.ticketsNum } 
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>